var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge badge-pill badge-measurement",class:'badge-' + _vm.colorBadge},[_vm._v(_vm._s(_vm.moment(_vm.controlDate).format('DD/MM/Y')))])}
var staticRenderFns = []

export { render, staticRenderFns }